'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbsStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BreadcrumbsStyled = exports.BreadcrumbsStyled = _styledComponents2.default.nav.withConfig({
  displayName: 'BreadcrumbsStyled'
})(['display:flex;max-width:100%;list-style-type:none;padding:0;margin:0;']);